import {
  VStack,
  Link as ChakraLink,
  Text,
  HTMLChakraProps,
} from '@chakra-ui/react';
import CustomImage from './CustomImage';
import linkIcon from '../assets/link.svg';
import { EXPLORER, GAME_NETWORK_TO_CHAIN } from '../constants/chain';
import useNetworkTxnParam from '../hooks/useNetworkTxnParam';
import {
  reselectGameAdminInfo,
  reselectGameMoneyConfig,
} from '../slice/reselectors';
import { useSelector } from 'react-redux';
import { useIsMobile } from '../hooks/useMobile';

// table info
const GameTableInfo = ({ ...rest }: HTMLChakraProps<'div'>) => {
  const { adminNickname } = useSelector(reselectGameAdminInfo);
  const { bigBlind, smallBlind, gameStatus } = useSelector(
    reselectGameMoneyConfig
  );
  const { gameContractAddress, gameNetwork } = useNetworkTxnParam();
  const contractExplorer = gameContractAddress
    ? `${
        EXPLORER[GAME_NETWORK_TO_CHAIN[gameNetwork].id]
      }address/${gameContractAddress}`
    : undefined;
  const { isMobile } = useIsMobile();
  return (
    <VStack
      fontSize={'xs'}
      color="c-102"
      alignItems={'flex-start'}
      spacing={1}
      {...rest}
    >
      {!!gameContractAddress && (
        <Text color={isMobile ? 'c-105' : ''}>
          Table Address:{' '}
          <ChakraLink
            display={'inline-flex'}
            alignItems={'center'}
            gap={1}
            isExternal
            href={contractExplorer}
          >
            <Text as="span" color={isMobile ? 'c-103' : 'white'}>
              {gameContractAddress}
            </Text>
            {!isMobile && <CustomImage src={linkIcon} alt="link" boxSize={3} />}
          </ChakraLink>
        </Text>
      )}
      {!!adminNickname && (
        <Text
          maxW={'9.75rem'}
          overflow={'hidden'}
          textOverflow={'ellipsis'}
          whiteSpace={'nowrap'}
          color={isMobile ? 'c-105' : ''}
        >
          Admin:{' '}
          <Text as="span" color={isMobile ? 'c-103' : 'white'}>
            {adminNickname}
          </Text>
        </Text>
      )}
      {!!bigBlind && !!smallBlind && (
        <Text color={isMobile ? 'c-105' : ''}>
          NLH:{' '}
          <Text as="span" color={isMobile ? 'c-103' : 'white'}>
            {smallBlind} / {bigBlind}
          </Text>
        </Text>
      )}
    </VStack>
  );
};

export default GameTableInfo;
